import { useEffect } from 'react';

interface UseCloseDialogArgs {
  dialogRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

/**
 * Hook which calls a close function when user clicks outside of an element
 * @param {React.RefObject} dialogRef ref instance of an element
 * @param {function} onClose close function
 */
const useCloseOnOutsideTouch = ({ dialogRef, onClose }: UseCloseDialogArgs) => {
  useEffect(() => {
    const clickHandler = (event: MouseEvent | TouchEvent) => {
      if (!dialogRef.current || (event.target instanceof Element && dialogRef.current.contains(event.target))) {
        return;
      }

      onClose();
    };

    document.addEventListener('touchstart', clickHandler);

    return () => {
      document.removeEventListener('touchstart', clickHandler);
    };
  }, [onClose, dialogRef]);
};

export default useCloseOnOutsideTouch;
